import React, {useEffect} from 'react';
import FormationContext from "../../helpers/FormationContext";
import formationBanner from "../../assets/img/formation-banner.jpg";
import {Link, useMatches, useNavigate, useParams} from "react-router-dom";
import {getData} from "../../services/formation.service";
import FormationCard from "../../components/Ui/FormationCard";
import AppBar from "../../components/Layout/AppBar";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import { Button } from "@mui/material";
import {DEFAULT_BACKEND_URL} from "../../helpers/env";

function FormationDetails(props) {
    const [otherFormations, setOtherFormations] = React.useState([]);

    const [selectedFormation, setSelectedFormation] = React.useState({});
    const [link, setLink] = React.useState("");

    const navigate = useNavigate();

    const params = useParams();
    const id = params.id;

    const getYoutubeLink = () => {
        const splits = selectedFormation.links.split("/");
        const vidId = splits[splits.length - 1];
        return `https://youtube.com/embed/${vidId}`;
    };
    const getLink = () => {
            const splits = selectedFormation.links.split("/");
            const vidId = splits[splits.length - 1];
            return `${vidId}`;
    };

    useEffect(() => {
        console.log(id)
        getData("slug="+id).then((data) => {
            setSelectedFormation(data[0]);
        });
    }, []);

    useEffect(() => {
        if (selectedFormation.thematic === undefined) return;
        getData("thematicId="+selectedFormation.thematic.id).then((data) => {
            let formations = data.filter((formation) => formation.id !== selectedFormation.id);
            setOtherFormations(formations.slice(0, 5));
            setLink(selectedFormation.type==="video" ? getYoutubeLink() : getLink());
        });
    }, [selectedFormation]);

    const image = (name) => {
        return `${DEFAULT_BACKEND_URL}/formation/`+name;
    }

    return (
        <>
            <div className="pt-4">
                <AppBar />
            </div>
            <div className="primary font-bold underline my-5 px-10"><Link to={"/formations"}>
                 <Button  startIcon={<ChevronLeft/>}  size="small" variant="outlined">Liste des formations</Button>
                </Link>
                </div>
            <div className="flex px-10" style={{ gap: "3rem" }}>
                <div className="flex flex-col my-5" style={{ width:"200%" }}>
                    <div className="my-1">
                        <h1 className={"text-2xl font-bold"}>{selectedFormation.title}</h1>
                    </div>
                    <div>
                        <p>{selectedFormation.resume}</p>
                    </div>
                    <div className="mb-10">
                        {
                            selectedFormation.type === "text"
                                ? <p>{selectedFormation.content}</p>
                                :((selectedFormation.type === "audio")  
                                    ? <div> <h4 style={{ color:"orange" }}>Cliquez sur play pour lire l'audio</h4> <audio controls src={link} style={{ width:"100%" }}> Votre navigateur ne supporte pas le type audio.</audio></div>
                                    : ((selectedFormation.type === "document") 
                                        ? <iframe src={link} title={selectedFormation.title} height="1200px" width="100%" />
                                        : <iframe src={link} style={{ aspectRatio: "16 / 9",width:"100%" }} title={selectedFormation.title}></iframe>
                                    ))
                        }
                    </div>
                </div>
                <div className="flex flex-col"  style={{ width:"70%" }}>
                    <h1 className="">Dans la même catégorie</h1>
                    {
                        otherFormations.map((formation) => (
                            <a href={"/formations/"+formation.slug} key={formation.id} className="my-2"
                                 onClick={() => {
                                     navigate("/formations/"+formation.slug);
                                 }}
                            >
                                <FormationCard
                                key={formation.id}
                                id={formation.id}
                                title={formation.title}
                                image={formation.image}
                                type={formation.type}
                                thematic={formation.thematic}
                                slug={formation.slug}
                            /></a>
                        ))
                    }
                </div>
            </div>
        </>
    );
}

export default FormationDetails;